import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "./App.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store";
import { MoralisProvider } from "react-moralis";
import { BrowserRouter } from "react-router-dom";
ReactDOM.render(
  <BrowserRouter>
    <MoralisProvider
      serverUrl="https://5wfprtmwylvv.usemoralis.com:2053/server"
      appId="4POOdIXAF7iR0GFWMcEnJZInDRq1nosUVtWRcnho"
    >
      <Provider store={store}>
        <App />
      </Provider>
    </MoralisProvider>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals())
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
